import React, { useCallback, useState, useEffect } from 'react';
import {
  AdvancedMarker,
  AdvancedMarkerAnchorPoint,
  useAdvancedMarkerRef
} from '@vis.gl/react-google-maps';
import { Gaz } from 'components/CustomIcon/CustomIcon';
import { Electricity } from 'components/CustomIcon/CustomIcon';
import { Water } from 'components/CustomIcon/CustomIcon';
import { Fuel } from 'components/CustomIcon/CustomIcon';
import { Heat } from 'components/CustomIcon/CustomIcon';
import { Cold } from 'components/CustomIcon/CustomIcon';
import { Wood } from 'components/CustomIcon/CustomIcon';
import { Propane } from 'components/CustomIcon/CustomIcon';
import { Meter } from 'components/CustomIcon/CustomIcon';

export const FeaturesClusterMarker = ({
  position,
  size,
  sizeAsText,
  onMarkerClick,
  clusterId,
  energy,
  overSiteId,
  activeSiteId,
  leaves,
}) => {
  const [markerRef, marker] = useAdvancedMarkerRef();
  const [specialcolor, setSpecialcolor] = useState(false);

  useEffect(() => {
    let specialcolortmp = false;
    leaves.forEach((leave) => {
      if ((!activeSiteId && overSiteId && overSiteId === leave.id) || (activeSiteId && activeSiteId === leave.id)) {
        specialcolortmp = true;
        return;
      }
    });
    setSpecialcolor(specialcolortmp);
  }, [overSiteId,activeSiteId]);

  const handleClick = useCallback(
    () => onMarkerClick && onMarkerClick(marker, clusterId),
    [onMarkerClick, marker, clusterId]
  );
  const markerSize = Math.floor(54 + Math.sqrt(size) * 2);
  return (
    <AdvancedMarker
      ref={markerRef}
      position={position}
      zIndex={size}
      onClick={handleClick}
      className={'marker cluster'}
      style={{
        width: markerSize, height: markerSize, background: specialcolor ? '#91C73C' : '#605f70'
      }}
      anchorPoint={AdvancedMarkerAnchorPoint.CENTER}>
      {
        energy === 'electricity' ? <Electricity style={{ color: "#FFFFFF" }} /> :
          energy === 'gas' ? <Gaz style={{ color: "#FFFFFF" }} /> :
            energy === 'water' ? <Water style={{ color: "#FFFFFF" }} /> :
              energy === 'fuel' ? <Fuel style={{ color: "#FFFFFF" }} /> :
                energy === 'heat' ? <Heat style={{ color: "#FFFFFF" }} /> :
                  energy === 'cold' ? <Cold style={{ color: "#FFFFFF" }} /> :
                    energy === 'wood' ? <Wood style={{ color: "#FFFFFF" }} /> :
                      energy === 'propane' ? <Propane style={{ color: "#FFFFFF" }} /> : <Meter style={{ color: "#FFFFFF" }} />
      }
      <span>{sizeAsText}</span>
    </AdvancedMarker>
  );
};
